import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultadosComponent } from './resultados.component';
import { RouterModule, Routes } from '@angular/router';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatSidenavModule} from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ChartsModule } from 'ng2-charts';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { IntroduccionComponent } from './introduccion/introduccion.component';
import { GeneralesComponent } from './generales/generales.component';
import { MenuResultadosComponent } from './menu-resultados/menu-resultados.component';
import { NoRespondieronComponent } from './no-respondieron/no-respondieron.component';
import { AtRespuestasEncuestaComponent } from './at-respuestas-encuesta/at-respuestas-encuesta.component';
import { SufrieronAcontecimientoComponent } from './sufrieron-acontecimiento/sufrieron-acontecimiento.component';
import { RequierenAtencionComponent } from './requieren-atencion/requieren-atencion.component';
import { FrpRespuestasEncuestaComponent } from './frp-respuestas-encuesta/frp-respuestas-encuesta.component';
import { FrpResultadosIndividualesComponent } from './frp-resultados-individuales/frp-resultados-individuales.component';
import { TableroGlobalComponent } from './tablero-global/tablero-global.component';
import { TableroCategoriaComponent } from './tablero-categoria/tablero-categoria.component';
import { TableroDominioComponent } from './tablero-dominio/tablero-dominio.component';
import { CalificacionFinalComponent } from './calificacion-final/calificacion-final.component';
import { CentrosDeTrabajoComponent } from './centros-de-trabajo/centros-de-trabajo.component';

const rutas: Routes = [
    // trust index
    {
        path     : 'NOM35/resultados',
        component: ResultadosComponent,
        canActivate: [AuthGuard],
    },
    {path: 'NOM35/menu-resultados',
    component: MenuResultadosComponent,
    canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [ResultadosComponent, IntroduccionComponent, GeneralesComponent, MenuResultadosComponent, NoRespondieronComponent, AtRespuestasEncuestaComponent, SufrieronAcontecimientoComponent, RequierenAtencionComponent, FrpRespuestasEncuestaComponent, FrpResultadosIndividualesComponent, TableroGlobalComponent, TableroCategoriaComponent, TableroDominioComponent, CalificacionFinalComponent, CentrosDeTrabajoComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    MatStepperModule,
    MatButtonModule,
    FlexLayoutModule,
    MatSidenavModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatInputModule,
    MatCardModule,
    ScrollingModule,
    MatTableModule,
    MatTooltipModule,
    ChartsModule,
    MatProgressSpinnerModule
  ]
})
export class ResultadosModule { }
